var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployerIco1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2331_12536)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2331_12536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.735 35.2902L37.2535 26.5498V7.51855C37.2535 6.79258 36.667 6.20605 35.941 6.20605H7.06605C6.34007 6.20605 5.75355 6.79258 5.75355 7.51855V26.5498L3.2721 35.2902C2.96449 36.1475 3.59613 37.0498 4.50667 37.0498H38.5004C39.411 37.0498 40.0426 36.1475 39.735 35.2902ZM8.70667 9.15918H34.3004V25.3604H8.70667V9.15918V9.15918ZM18.0705 34.0967L18.4028 32.5791H24.5674L24.8996 34.0967H18.0705V34.0967ZM27.258 34.0967L26.4746 30.5406C26.4418 30.3889 26.3065 30.2822 26.1547 30.2822H16.8196C16.6637 30.2822 16.5325 30.3889 16.4996 30.5406L15.7162 34.0967H6.6805L8.41546 27.9854H34.5916L36.3266 34.0967H27.258Z",
    fill: "#17B67C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2331_12536",
    x: -0.806641,
    y: 6.20605,
    width: 44.6211,
    height: 38.8438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2331_12536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2331_12536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2331_12536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.503906 0.62793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployerIco1);
export default __webpack_public_path__ + "static/media/employer_ico_1.12eb60b13db06639983d67995c2c4117.svg";
export { ForwardRef as ReactComponent };